import React from "react";
/** Components Import */
import Card from "./Card_wrap";
import BasicInput from "./Input_Basic";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";

function Checking(
  { datas = [] },
  portalId,
  popperClassName,
  style,
  showIcon,
  selected,
  onChange,
  dateFormat,
  disabled,
  className
) {
  const ChangeDatapicker = (e) => {
    onChange(e);
  };
  return (
    <Card>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {datas.map((item, index) => {
          const ReturnInputs = () => {
            switch (item.type) {
              case "file":
                return (
                  <div key={index} className="input_set">
                    {item.name === "" ? null : <label>{item.name}</label>}
                    <input
                      key={index}
                      type="file"
                      onChange={(e) => item.onChange(e)}
                      // accept="image/*"
                    />
                  </div>
                );
              case "image":
                return <img id={item.id} src={item.src} />;
              default:
                return (
                  <BasicInput
                    key={index}
                    style={{ width: "400px" }}
                    // containerStyle={{ width: "280px" }}
                    disabled={item.disabled}
                    id={item.id}
                    name={item.name}
                    value={item.value}
                    onChange={(e) => item.onChange(e)}
                    onClick={() => {}}
                    onKeyDown={() => {}}
                  />
                );
            }
          };
          return (
            <div>
              {/* <label>{item.name}</label> */}
              {ReturnInputs()}
            </div>
          );
        })}
      </div>
    </Card>
  );
}

Checking.defaultProps = {};

export default Checking;
